module.exports = __webpack_public_path__ + "static/media/es-editor.e4e7526.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/es-editor.mp4
// module id = LMwh
// module chunks = 1